import React from 'react';
import { payNow } from '../assets/images';
import style from './components.module.css';

const NavigationButtons = ({
    back,
    next,
    payment,
    hideNext = false,
    isLoading = false,
    isBackDisabled = false,
    isNextDisabled = false,
    loading
}) => {
    return(
        <div className={style.navigationButtons}>
            <button disabled={isBackDisabled} className={isBackDisabled ? style.navigationButtons_back_disabled : style.navigationButtons_back} onClick={back}>
               {'< Back'}
            </button>
           {!hideNext && <button disabled={isLoading || isNextDisabled} className={isNextDisabled ? style.navigationButtons_next_disabled : style.navigationButtons_next} onClick={() => {
                next();
            } }>
                {/* {isLoading ? <div class="lds-ring"><div></div><div></div><div></div></div> : (payment ? 'Submit' : 'Next >')} */}
                {loading ? <div class="lds-ring"><div></div><div></div><div></div></div> : (payment ? 'Submit' : 'Next >')}
            </button>}
        </div>
    )
}

export default NavigationButtons;